<template>
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
  >
    <path d="M5.00001 0C5.41422 0 5.75001 0.335786 5.75001 0.75V9.53698L8.69108 6.24991C8.96727 5.94122 9.44141 5.91488 9.7501 6.19107C10.0588 6.46727 10.0851 6.94141 9.80894 7.2501L5.55894 12.0001C5.41666 12.1591 5.21339 12.25 5.00001 12.25C4.78663 12.25 4.58336 12.1591 4.44108 12.0001L0.191076 7.2501C-0.0851192 6.94141 -0.0587782 6.46727 0.249911 6.19107C0.5586 5.91488 1.03274 5.94122 1.30894 6.24991L4.25001 9.53698V0.75C4.25001 0.335786 4.5858 0 5.00001 0Z" />
  </svg>
</template>
